<template>
  <label
    @click="toggleFilter"
    @keypress="toggleFilterFromKeyPress"
    :for="name + id"
    :class="[
      selected ? 'filter-button-label--selected' : 'filter-button-label',
    ]"
  >
    <div class="button filter-button button-tertiary" tabindex="0">
      {{ name }}
      <input
        class="filter-button-checkbox"
        tabindex="-1"
        type="checkbox"
        :checked="selected"
        :id="id"
        :name="name"
        :value="id"
      />
    </div>
  </label>
</template>

<script>
import Vue from "vue";

export default Vue.component("FilterButton", {
  props: {
    id: String,
    name: String,
    removeFilterFromButton: Function,
    selected: Boolean,
    selectedFilters: Array,
    updateFilterFromButton: Function,
  },
  methods: {
    toggleFilter: function (event) {
      if (event.target.checked) {
        this.updateFilterFromButton();
      } else {
        this.removeFilterFromButton();
      }
    },
    toggleFilterFromKeyPress: function (event) {
      if (event.keyCode == 32) {
        if (event.currentTarget.className == "filter-button-label--selected") {
          this.removeFilterFromButton();
        } else {
          this.updateFilterFromButton();
        }
        event.preventDefault();
      }
    }
  },
});
</script>